import { NextPage, NextPageContext } from "next";
import dynamic from "next/dynamic";
import Auth from "@layouts/Auth";
import { canonicalLink } from "@helpers/url";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { localeKey } from "@constants/locale-key";

const PageConfirmUsername = dynamic(
  () => {
    return import("@containers/ConfirmUsername/ConfirmUsername");
  },
  { ssr: false },
);

const ConfirmUsernamePage: NextPage = () => {
  return (
    <Auth title="Lupa Password - Konfirmasi Username">
      <PageConfirmUsername />
    </Auth>
  );
};

export async function getStaticProps({ locale }: NextPageContext) {
  return {
    props: {
      ...(await serverSideTranslations(locale ?? "id", localeKey)),
      title: "Lupa Password - Username",
      description: "MyTEnS masukkan email atau nomor ponsel Anda",
      imageUrl: "https://storage-assurance-dev.mytens.id/assets/mytenscustomer/bglogin.png",
      canonical: canonicalLink("/lupa-password/konfirmasi-username", locale),
    },
  };
}

export default ConfirmUsernamePage;
